/**
 * Create account — same screen as sign-in (`/sign-in?signup=1`). This route only preserves old links.
 */

import { useMemo } from 'react'
import { Redirect, useLocalSearchParams, type Href } from 'expo-router'
import { buildPublicSignInHref } from '../src/signIn/helpers/postAuthRedirect.helper'

export default function SignUpRedirectScreen() {
  const params = useLocalSearchParams<{ returnUrl?: string | string[] }>()
  const href = useMemo(
    () => buildPublicSignInHref({ signup: true, returnUrl: params.returnUrl }) as Href,
    [params.returnUrl],
  )
  return <Redirect href={href} />
}
